var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "divBox relative" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "hasPermi",
            rawName: "v-hasPermi",
            value: ["platform:lottery:record:list"],
            expression: "['platform:lottery:record:list']",
          },
        ],
      },
      [
        _c(
          "el-card",
          {
            staticClass: "ivu-mt",
            attrs: {
              bordered: false,
              shadow: "never",
              "body-style": { padding: 0 },
            },
          },
          [
            _c(
              "div",
              { staticClass: "padding-add" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      inline: "",
                      size: "small",
                      "label-position": "right",
                    },
                    nativeOn: {
                      submit: function ($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "活动编号：" } },
                      [
                        _c("el-input", {
                          staticClass: "selWidth",
                          attrs: {
                            placeholder: "请输入活动编号",
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery($event)
                            },
                          },
                          model: {
                            value: _vm.queryParams.activityId,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryParams,
                                "activityId",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "queryParams.activityId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "手机号：" } },
                      [
                        _c("el-input", {
                          staticClass: "selWidth",
                          attrs: { placeholder: "请输入手机号", clearable: "" },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery($event)
                            },
                          },
                          model: {
                            value: _vm.queryParams.phoneNumber,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryParams,
                                "phoneNumber",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "queryParams.phoneNumber",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.handleQuery },
                          },
                          [_vm._v("查询")]
                        ),
                        _c("el-button", { on: { click: _vm.resetQuery } }, [
                          _vm._v("重置"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
        _c(
          "el-card",
          {
            staticClass: "table-card mt14",
            attrs: { "body-style": { padding: "20px" } },
          },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                staticStyle: { width: "100%" },
                attrs: { data: _vm.recordList, size: "small" },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "activityId",
                    label: "活动编号",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "activityName",
                    label: "活动名称",
                    "show-overflow-tooltip": true,
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "lotteryTime",
                    label: "抽奖时间",
                    width: "160",
                  },
                }),
                _c("el-table-column", {
                  attrs: { prop: "awardName", label: "奖项名称" },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "prizeName",
                    label: "奖品名称",
                    "show-overflow-tooltip": true,
                  },
                }),
                _c("el-table-column", {
                  attrs: { prop: "prizeType", label: "奖品类型", width: "120" },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "prizeStatus",
                    label: "奖品状态",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: { prop: "phoneNumber", label: "手机号", width: "120" },
                }),
                _c("el-table-column", {
                  attrs: { prop: "orderNo", label: "订单号", width: "160" },
                }),
              ],
              1
            ),
            _c("el-pagination", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.total > 0,
                  expression: "total > 0",
                },
              ],
              attrs: {
                background: "",
                "current-page": _vm.queryParams.page,
                "page-size": _vm.queryParams.limit,
                "page-sizes": [10, 20, 30, 50],
                layout: "total, sizes, prev, pager, next, jumper",
                total: _vm.total,
              },
              on: {
                "update:currentPage": function ($event) {
                  return _vm.$set(_vm.queryParams, "page", $event)
                },
                "update:current-page": function ($event) {
                  return _vm.$set(_vm.queryParams, "page", $event)
                },
                "update:pageSize": function ($event) {
                  return _vm.$set(_vm.queryParams, "limit", $event)
                },
                "update:page-size": function ($event) {
                  return _vm.$set(_vm.queryParams, "limit", $event)
                },
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }